export const t = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      portfolio: 'Réalisations',
      process: 'Processus',
      about: 'À propos',
      faq: 'FAQ',
      contact: 'Contact',
      quote: 'Demander un devis',
    },
    hero: {
      overline: 'Agence Numérique',
      title: 'Développement web, SaaS et solutions numériques sur mesure',
      subtitle: 'Exevori conçoit des sites web modernes, des applications performantes et des solutions digitales intelligentes pour aider les entreprises à gagner en crédibilité, en efficacité et en croissance.',
      cta1: 'Demander un devis',
      cta2: 'Découvrir nos services',
    },
    credibility: {
      title: 'Une expertise complète, une approche sur mesure',
      items: [
        { title: 'Design haut de gamme', desc: 'Sites modernes qui inspirent confiance' },
        { title: 'Solutions sur mesure', desc: 'Développement adapté à vos besoins réels' },
        { title: 'Automatisation intelligente', desc: 'Gagnez du temps avec nos outils IA' },
        { title: 'Performance garantie', desc: 'Sites rapides, optimisés, fiables' },
        { title: 'Accompagnement humain', desc: 'Un partenaire à chaque étape du projet' },
        { title: 'Vision business', desc: 'Des solutions pensées pour votre croissance' },
      ]
    },
    services: {
      overline: 'Nos Services',
      title: 'Des solutions numériques pour chaque besoin',
      subtitle: 'Exevori offre une gamme complète de services pour propulser votre présence numérique et optimiser vos opérations.',
      learnMore: 'En savoir plus',
      items: [
        {
          title: 'Développement de sites web',
          desc: 'Création de sites vitrines modernes, rapides et orientés conversion, pensés pour représenter votre marque avec professionnalisme.',
          icon: 'Globe',
        },
        {
          title: 'Applications web sur mesure',
          desc: 'Plateformes, espaces clients, tableaux de bord et outils internes développés selon vos besoins précis.',
          icon: 'Code2',
        },
        {
          title: 'Solutions SaaS',
          desc: 'Conception de logiciels web spécialisés pour des besoins métiers spécifiques ou des niches précises.',
          icon: 'Layers',
        },
        {
          title: 'Automatisation des processus',
          desc: 'Automatisation de tâches répétitives, formulaires, suivis et workflows pour gagner en efficacité.',
          icon: 'Zap',
        },
        {
          title: 'IA pour entreprises',
          desc: 'Intégration de fonctionnalités intelligentes pour améliorer l\'expérience client et optimiser vos opérations.',
          icon: 'Brain',
        },
        {
          title: 'Refonte et optimisation',
          desc: 'Modernisation de votre site existant : UX/UI, performance, crédibilité de marque et référencement.',
          icon: 'RefreshCw',
        },
      ]
    },
    whyExevori: {
      overline: 'Pourquoi Exevori ?',
      title: 'Une image professionnelle qui fait la différence',
      items: [
        {
          title: 'Solutions personnalisées',
          desc: 'Chaque projet est unique. Nous concevons des solutions qui répondent exactement à vos objectifs et à votre réalité d\'entreprise.',
        },
        {
          title: 'Design professionnel',
          desc: 'Des interfaces modernes, soignées et crédibles qui renforcent votre image et inspirent la confiance à vos clients.',
        },
        {
          title: 'Approche orientée résultats',
          desc: 'Chaque décision technique est guidée par votre succès business, pas seulement par la technologie.',
        },
        {
          title: 'Accompagnement complet',
          desc: 'De la stratégie à la mise en ligne, nous sommes à vos côtés à chaque étape avec clarté et transparence.',
        },
      ]
    },
    portfolio: {
      overline: 'Réalisations',
      title: 'Des projets conçus pour performer',
      subtitle: 'Découvrez quelques exemples de solutions que nous avons développées.',
      viewAll: 'Voir toutes les réalisations',
      projects: [
        {
          name: 'Site Construction',
          type: 'Site Web',
          client: 'Entreprise de construction',
          desc: 'Site web professionnel avec présentation des services, portfolio de réalisations et formulaire de demande de devis.',
          tags: ['React', 'Design Premium', 'SEO'],
        },
        {
          name: 'Site Plomberie',
          type: 'Site Web',
          client: 'Service de plomberie',
          desc: 'Site vitrine moderne avec système de contact rapide et présentation des services.',
          tags: ['React', 'Responsive', 'Contact'],
        },
        {
          name: 'Site Restaurant',
          type: 'Site Web Premium',
          client: 'Restaurant',
          desc: 'Site web élégant avec menu interactif, système de réservation en ligne et galerie photo.',
          tags: ['React', 'Design Luxe', 'Réservations'],
        },
      ]
    },
    process: {
      overline: 'Notre Processus',
      title: 'Une méthode claire pour des résultats concrets',
      subtitle: 'Chaque projet suit un processus structuré qui garantit la qualité, la transparence et la livraison dans les délais.',
      steps: [
        { num: '01', title: 'Analyse du besoin', desc: 'Nous prenons le temps de comprendre vos objectifs, votre marché et vos contraintes avant de proposer quoi que ce soit.' },
        { num: '02', title: 'Stratégie et cadrage', desc: 'Définition claire du périmètre, des fonctionnalités, de l\'architecture et du calendrier du projet.' },
        { num: '03', title: 'Design et UX', desc: 'Conception d\'interfaces modernes, intuitives et alignées avec votre image de marque.' },
        { num: '04', title: 'Développement', desc: 'Intégration et développement rigoureux avec des pratiques de code modernes et performantes.' },
        { num: '05', title: 'Lancement et optimisation', desc: 'Mise en ligne, tests approfondis, suivi post-lancement et optimisation continue selon les résultats.' },
      ]
    },
    testimonials: {
      overline: 'Témoignages',
      title: 'Ce que disent nos clients',
      items: []
    },
    finalCta: {
      title: 'Vous avez un projet digital ?',
      subtitle: 'Exevori vous aide à transformer votre idée en solution concrète, moderne et performante. Parlons de votre projet.',
      cta1: 'Parler de mon projet',
      cta2: 'Demander une estimation',
    },
    servicesPage: {
      hero: {
        overline: 'Nos Services',
        title: 'Des solutions numériques complètes pour votre entreprise',
        subtitle: 'De la conception au déploiement, Exevori vous accompagne avec expertise et professionnalisme.',
      },
      items: [
        {
          icon: 'Globe',
          title: 'Sites Web Professionnels',
          subtitle: 'Votre vitrine numérique, repensée',
          desc: 'Nous créons des sites web qui ne sont pas seulement beaux — ils sont pensés pour convertir. Chaque détail est soigné : architecture de l\'information, performance technique, design responsive et optimisation pour les moteurs de recherche.',
          benefits: [
            'Design moderne adapté à votre image de marque',
            'Optimisé pour le référencement local (SEO)',
            'Responsive parfait sur tous les appareils',
            'Formulaires de contact et intégrations',
            'Chargement rapide et code propre',
          ],
          clients: 'Commerçants, professionnels, PME, organismes',
        },
        {
          icon: 'Code2',
          title: 'Applications Web Sur Mesure',
          subtitle: 'Des outils à votre image, taillés pour votre réalité',
          desc: 'Quand les solutions génériques ne suffisent plus, nous développons des applications web entièrement personnalisées. Espaces clients, portails de gestion, tableaux de bord analytiques, systèmes de réservation — tout ce dont votre entreprise a besoin pour opérer efficacement.',
          benefits: [
            'Architecture scalable et maintenable',
            'Interface utilisateur intuitive et moderne',
            'Intégration avec vos outils existants',
            'Base de données sur mesure',
            'Sécurité et performance garanties',
          ],
          clients: 'PME, entreprises en croissance, startups',
        },
        {
          icon: 'Layers',
          title: 'Solutions SaaS',
          subtitle: 'Votre idée transformée en logiciel',
          desc: 'Vous avez une idée de produit numérique ou un besoin métier spécifique ? Exevori conçoit et développe des mini SaaS clés en main : de la stratégie produit à l\'interface utilisateur, en passant par l\'architecture technique et la mise en ligne.',
          benefits: [
            'MVP rapide pour valider votre idée',
            'Architecture cloud-native',
            'Système de gestion des utilisateurs',
            'Tableau de bord administrateur',
            'Évolutif selon votre croissance',
          ],
          clients: 'Entrepreneurs, startups, entreprises en innovation',
        },
        {
          icon: 'Zap',
          title: 'Automatisation des Processus',
          subtitle: 'Libérez votre temps pour l\'essentiel',
          desc: 'Nous analysons vos opérations et identifions les tâches répétitives qui peuvent être automatisées. Formulaires intelligents, workflows de traitement, notifications automatiques, synchronisation de données — vos équipes gagnent en productivité.',
          benefits: [
            'Réduction des tâches manuelles répétitives',
            'Workflows déclenchés automatiquement',
            'Notifications et rappels intelligents',
            'Intégration avec vos outils métiers',
            'Suivi et rapports automatisés',
          ],
          clients: 'Toutes entreprises voulant gagner en efficacité',
        },
        {
          icon: 'Brain',
          title: 'Intelligence Artificielle pour Entreprises',
          subtitle: 'La technologie au service de votre performance',
          desc: 'L\'IA n\'est plus réservée aux grandes entreprises. Exevori intègre des fonctionnalités intelligentes dans vos outils : assistants virtuels, analyse de données, génération de contenu, classification automatique et bien plus.',
          benefits: [
            'Chatbots et assistants virtuels',
            'Analyse et synthèse de données',
            'Automatisation intelligente par IA',
            'Personnalisation de l\'expérience client',
            'Rapports et insights automatiques',
          ],
          clients: 'PME souhaitant innover et se démarquer',
        },
        {
          icon: 'RefreshCw',
          title: 'Refonte et Optimisation Digitale',
          subtitle: 'Modernisez votre présence numérique',
          desc: 'Votre site existant ne reflète plus votre image actuelle ? Exevori réalise des refontes complètes ou partielles : nouvelle identité visuelle, amélioration de l\'UX, optimisation des performances et du SEO, mise à jour technologique.',
          benefits: [
            'Audit complet de l\'existant',
            'Nouvelle identité visuelle moderne',
            'Amélioration significative de la vitesse',
            'UX repensée pour convertir davantage',
            'Migration sécurisée sans perte de données',
          ],
          clients: 'Entreprises avec un site web vieillissant',
        },
      ]
    },
    portfolioPage: {
      hero: {
        overline: 'Nos Réalisations',
        title: 'Des projets qui parlent d\'eux-mêmes',
        subtitle: 'Chaque projet que nous livrons est le résultat d\'une collaboration étroite, d\'une expertise technique rigoureuse et d\'un design soigné.',
      },
      filters: ['Tous', 'Site Web', 'Application', 'SaaS'],
      projects: [
        {
          name: 'Site Construction',
          type: 'Site Web',
          category: 'Site Web',
          client: 'Entreprise de construction',
          location: '',
          desc: 'Site web professionnel avec présentation des services, portfolio de réalisations et formulaire de demande de devis.',
          objective: 'Créer une présence en ligne professionnelle et générer des demandes de devis',
          result: 'Interface moderne et professionnelle',
          tags: ['React', 'Design Premium', 'SEO', 'Responsive'],
          color: 'from-amber-500 to-orange-500',
          image: 'https://customer-assets.emergentagent.com/job_connected-work/artifacts/z7xoesbs_E2DAE32C-FC28-480A-82F7-2C22D3FC8514.png',
        },
        {
          name: 'Site Plomberie',
          type: 'Site Web',
          category: 'Site Web',
          client: 'Service de plomberie',
          location: '',
          desc: 'Site vitrine moderne avec système de contact rapide et présentation des services.',
          objective: 'Moderniser la présence web et faciliter les prises de contact',
          result: 'Interface intuitive et efficace',
          tags: ['React', 'Responsive', 'Contact', 'SEO'],
          color: 'from-blue-500 to-cyan-500',
          image: 'https://customer-assets.emergentagent.com/job_connected-work/artifacts/k8aburmo_E088F2AA-6C4A-4E33-978A-8F23A3FB2723.png',
        },
        {
          name: 'Site Restaurant',
          type: 'Site Web Premium',
          category: 'Site Web',
          client: 'Restaurant',
          location: '',
          desc: 'Site web élégant avec menu interactif, système de réservation en ligne et galerie photo.',
          objective: 'Refléter l\'ambiance du restaurant et simplifier les réservations',
          result: 'Design haut de gamme et fonctionnel',
          tags: ['React', 'Design Luxe', 'Réservations', 'Galerie'],
          color: 'from-amber-700 to-yellow-600',
          image: 'https://customer-assets.emergentagent.com/job_connected-work/artifacts/66utq2we_E1840B20-EFC3-4B4E-891E-21B6BEEA144B.png',
        },
        {
          name: 'ComptaPro IA',
          type: 'SaaS',
          category: 'SaaS',
          client: 'Solution en développement',
          location: '',
          desc: 'Logiciel de comptabilité assisté par intelligence artificielle pour automatiser la saisie, la catégorisation et les rapports financiers.',
          objective: 'Simplifier la comptabilité des PME grâce à l\'IA',
          result: 'En cours de développement',
          tags: ['React', 'FastAPI', 'IA', 'MongoDB'],
          color: 'from-violet-500 to-purple-700',
        },
        {
          name: 'AssistPro IA',
          type: 'SaaS',
          category: 'SaaS',
          client: 'Solution en développement',
          location: '',
          desc: 'Assistant virtuel intelligent pour les entreprises, capable de répondre aux questions clients et de qualifier les leads.',
          objective: 'Offrir un support client automatisé et intelligent',
          result: 'En cours de développement',
          tags: ['React', 'OpenAI', 'Node.js', 'Real-time'],
          color: 'from-emerald-500 to-teal-600',
        },
        {
          name: 'DevisPro IA',
          type: 'SaaS',
          category: 'SaaS',
          client: 'Solution en développement',
          location: '',
          desc: 'Plateforme de génération automatique de devis et propositions commerciales avec assistance IA.',
          objective: 'Accélérer la création de devis professionnels',
          result: 'En cours de développement',
          tags: ['React', 'FastAPI', 'IA', 'PDF'],
          color: 'from-cyan-500 to-blue-600',
        },
      ]
    },
    aboutPage: {
      hero: {
        overline: 'À Propos de Exevori',
        title: 'Une entreprise bâtie sur l\'expertise et la confiance',
        subtitle: 'Exevori accompagne les entreprises dans la création d\'outils numériques modernes, performants et utiles.',
      },
      story: {
        overline: 'Notre Histoire',
        title: 'Nés de la passion pour le numérique',
        desc1: 'Exevori est une agence de développement web et numérique. Nous avons été fondés avec une vision claire : rendre les technologies modernes accessibles et utiles pour les PME et les entrepreneurs.',
        desc2: 'Notre équipe combine stratégie, design, développement et vision business pour créer des solutions qui renforcent l\'image, l\'efficacité et la croissance de nos clients. Chaque projet est traité avec rigueur, créativité et un sens aigu des affaires.',
        desc3: 'Que vous ayez besoin d\'un site vitrine, d\'une application web complexe ou d\'une solution SaaS, Exevori est le partenaire technologique qui vous accompagnera de l\'idée au lancement.',
      },
      mission: {
        overline: 'Mission & Vision',
        title: 'Aider les entreprises à mieux performer grâce au numérique',
        mission: 'Notre mission est d\'aider les entreprises à bâtir une présence numérique forte, crédible et efficace grâce à des solutions modernes sur mesure.',
        vision: 'Notre vision est d\'être le partenaire numérique de référence pour les PME qui veulent se démarquer.',
      },
      values: {
        overline: 'Nos Valeurs',
        title: 'Ce qui nous guide chaque jour',
        items: [
          { title: 'Professionnalisme', desc: 'Nous traitons chaque projet avec le même sérieux et la même rigueur, quelle qu\'en soit la taille.' },
          { title: 'Innovation', desc: 'Nous utilisons les technologies les plus modernes pour vous offrir des solutions qui durent dans le temps.' },
          { title: 'Clarté', desc: 'Communication simple et transparente à chaque étape — pas de jargon, pas de surprises.' },
          { title: 'Qualité', desc: 'Nous ne livrons pas pour livrer. Chaque détail compte et chaque livrable doit vous rendre fier.' },
          { title: 'Confiance', desc: 'Nous construisons des relations durables basées sur le respect des engagements et la transparence.' },
          { title: 'Performance', desc: 'Des solutions optimisées, rapides et fiables qui soutiennent votre croissance sur le long terme.' },
        ]
      },
      cta: {
        title: 'Prêt à collaborer avec Exevori ?',
        subtitle: 'Discutons de votre projet et voyons comment nous pouvons vous aider à atteindre vos objectifs.',
        btn: 'Démarrer un projet',
      }
    },
    processPage: {
      hero: {
        overline: 'Notre Méthode',
        title: 'Un processus structuré pour des résultats prévisibles',
        subtitle: 'Nous avons développé une méthode de travail éprouvée qui garantit la qualité, la transparence et la livraison dans les délais convenus.',
      },
      steps: [
        {
          num: '01',
          title: 'Analyse du besoin',
          subtitle: 'Comprendre avant de proposer',
          desc: 'Tout commence par une discussion approfondie pour comprendre vos objectifs d\'affaires, votre marché, vos contraintes et vos attentes. Nous posons les bonnes questions pour cerner exactement ce dont vous avez besoin.',
          deliverables: ['Rapport d\'analyse des besoins', 'Identification des objectifs clés', 'Proposition de périmètre initial'],
        },
        {
          num: '02',
          title: 'Stratégie et Cadrage',
          subtitle: 'Définir clairement le plan d\'action',
          desc: 'Sur la base de l\'analyse, nous définissons la portée exacte du projet, les fonctionnalités prioritaires, l\'architecture technique, le calendrier et le budget. Tout est documenté et validé avec vous.',
          deliverables: ['Spécifications fonctionnelles', 'Architecture technique', 'Planning de projet détaillé'],
        },
        {
          num: '03',
          title: 'Design UX/UI',
          subtitle: 'Des interfaces qui convertissent',
          desc: 'Notre designer conçoit des interfaces modernes, intuitives et alignées avec votre image de marque. Nous créons des maquettes détaillées et les validons avec vous avant tout développement.',
          deliverables: ['Maquettes haute fidélité', 'Prototype interactif', 'Guide de style validé'],
        },
        {
          num: '04',
          title: 'Développement & Intégration',
          subtitle: 'Du code propre et performant',
          desc: 'Notre équipe développe la solution selon les meilleures pratiques modernes. Des revues régulières vous permettent de suivre l\'avancement et de valider les livrables au fur et à mesure.',
          deliverables: ['Code source documenté', 'Environnement de tests', 'Démonstrations régulières'],
        },
        {
          num: '05',
          title: 'Lancement & Optimisation',
          subtitle: 'Un go-live serein et un suivi rigoureux',
          desc: 'Nous gérons la mise en ligne, effectuons des tests approfondis et assurons un suivi post-lancement. Des optimisations basées sur les données réelles sont apportées pour maximiser les résultats.',
          deliverables: ['Mise en production', 'Formation et documentation', 'Rapport de performance post-lancement'],
        },
      ],
      getWith: {
        title: 'Ce que vous obtenez avec Exevori',
        items: [
          'Une vision claire et un plan structuré dès le départ',
          'Une communication simple et régulière tout au long du projet',
          'Des livrables professionnels à chaque étape validée',
          'Une expérience utilisateur moderne et soignée',
          'Une solution parfaitement adaptée à vos objectifs',
          'Un accompagnement après la mise en ligne',
        ]
      }
    },
    faqPage: {
      hero: {
        overline: 'FAQ',
        title: 'Vos questions, nos réponses',
        subtitle: 'Vous avez des questions sur nos services ou notre façon de travailler ? Trouvez les réponses ci-dessous.',
      },
      items: [
        {
          q: 'Quels types de projets réalisez-vous ?',
          a: 'Exevori réalise une grande variété de projets numériques : sites web vitrines, boutiques en ligne, applications web sur mesure, mini SaaS, CRM, portails clients, automatisation de processus et intégration de fonctionnalités IA. Si vous avez un besoin numérique, nous avons probablement la solution.',
        },
        {
          q: 'Travaillez-vous avec les PME et petites entreprises ?',
          a: 'Absolument. La majorité de nos clients sont des PME, des professionnels indépendants et des commerçants. Nous adaptons notre approche et nos solutions à votre réalité — budget, capacité interne, délais — sans compromis sur la qualité.',
        },
        {
          q: 'Proposez-vous des solutions entièrement sur mesure ?',
          a: 'Oui, c\'est notre spécialité. Contrairement aux solutions clés en main génériques, tout ce que nous développons est conçu spécifiquement pour vos besoins. Cela garantit une meilleure adéquation avec votre réalité d\'entreprise et un avantage concurrentiel réel.',
        },
        {
          q: 'Combien de temps prend un projet typique ?',
          a: 'La durée dépend de la complexité du projet. Un site vitrine simple peut être livré en 2 à 4 semaines. Une application web sur mesure prend généralement 6 à 12 semaines. Nous définissons un calendrier précis lors de la phase de cadrage et nous nous y tenons.',
        },
        {
          q: 'Peut-on faire évoluer le site ou l\'application plus tard ?',
          a: 'Oui, et c\'est essentiel. Nous développons avec une architecture scalable qui permet d\'ajouter des fonctionnalités, de modifier des sections ou d\'intégrer de nouveaux outils à mesure que votre entreprise évolue.',
        },
        {
          q: 'Offrez-vous un accompagnement après la livraison ?',
          a: 'Oui. Nous offrons un support post-lancement pour les corrections, les mises à jour et les optimisations. Nous pouvons aussi établir une entente de maintenance régulière selon vos besoins.',
        },
        {
          q: 'Peut-on moderniser un site existant ?',
          a: 'Tout à fait. La refonte de site est l\'un de nos services les plus demandés. Nous réalisons d\'abord un audit complet, puis proposons une refonte partielle ou totale selon l\'état de l\'existant et vos objectifs.',
        },
        {
          q: 'Proposez-vous des outils internes ou des SaaS ?',
          a: 'Oui. Nous développons des outils internes sur mesure (CRM, portails, tableaux de bord) et des mini SaaS pour des niches spécifiques. Si vous avez une idée de produit numérique, nous pouvons vous aider à la concrétiser.',
        },
        {
          q: 'Est-il possible d\'intégrer des fonctions d\'automatisation ou d\'IA ?',
          a: 'Absolument. Nous intégrons des solutions d\'automatisation (workflows, notifications, traitements) et des fonctionnalités IA (chatbots, analyse de données, génération de contenu) dans vos projets selon vos besoins.',
        },
        {
          q: 'Comment demander une soumission ?',
          a: 'C\'est simple : remplissez notre formulaire de demande de devis en cliquant sur "Demander un devis" en haut de page. Décrivez votre projet en détail et nous vous répondrons dans les 24 à 48 heures ouvrables avec une proposition adaptée.',
        },
        {
          q: 'Quels sont vos tarifs ?',
          a: 'Nos tarifs sont transparents et adaptés à différents types de projets :\n\n• Mise à jour ou refonte légère d\'un site existant : 800 $ à 1 200 $\n• Site vitrine simple et professionnel (5 à 10 pages) : 1 200 $ à 1 800 $\n• Projet web sur mesure ou plus complexe (e-commerce, automatisations, intégrations) : à partir de 3 000 $\n\nChaque projet est unique et nous fournissons toujours une soumission détaillée et sans engagement après une première consultation gratuite.',
        },
      ]
    },
    contactPage: {
      hero: {
        overline: 'Contact',
        title: 'Parlons de votre projet',
        subtitle: 'Parlez-nous de votre projet. Nous vous répondrons avec sérieux, clarté et professionnalisme.',
      },
      form: {
        name: 'Nom complet',
        company: 'Entreprise (optionnel)',
        email: 'Adresse courriel',
        phone: 'Téléphone (optionnel)',
        projectType: 'Type de projet',
        projectTypes: ['Site web vitrine', 'Application web', 'SaaS / Outil numérique', 'Automatisation', 'Refonte de site', 'Autre'],
        budget: 'Budget approximatif',
        budgets: ['Moins de 800 $', '800 $ – 1 200 $', '1 200 $ – 1 800 $', '1 800 $ – 3 000 $', '3 000 $ et plus'],
        message: 'Décrivez votre projet',
        messagePlaceholder: 'Parlez-nous de votre projet, vos besoins et vos objectifs...',
        submit: 'Envoyer le message',
        sending: 'Envoi en cours...',
        success: 'Votre message a été envoyé avec succès ! Nous vous répondrons sous 24-48h.',
        error: 'Une erreur s\'est produite. Veuillez réessayer.',
      },
      info: {
        title: 'Nos coordonnées',
        address: '114 rue des Pruniers, Lévis, QC G6V 8W2',
        phone: '(581) 700-4171',
        email: 'contact@exevori.com',
        hours: 'Lundi – Vendredi : 9h à 17h',
        response: 'Réponse sous 24-48h ouvrables',
      }
    },
    devisPage: {
      hero: {
        overline: 'Demande de Devis',
        title: 'Décrivez votre projet',
        subtitle: 'Chaque projet commence par une bonne compréhension de vos objectifs. Donnez-nous un maximum d\'informations pour recevoir une réponse claire et adaptée.',
      },
      form: {
        personal: 'Vos coordonnées',
        project: 'Votre projet',
        name: 'Nom complet',
        company: 'Entreprise',
        email: 'Adresse courriel',
        phone: 'Téléphone',
        sector: 'Secteur d\'activité',
        sectors: ['Commerce / Retail', 'Services professionnels', 'Santé / Bien-être', 'Construction / Immobilier', 'Restauration / Hôtellerie', 'Technologie', 'Éducation', 'Autre'],
        need: 'Besoin principal',
        needs: ['Créer un nouveau site web', 'Développer une application', 'Créer un SaaS', 'Automatiser des processus', 'Refonte de site existant', 'Intégration IA', 'Autre'],
        solution: 'Type de solution recherchée',
        solutions: ['Site vitrine', 'E-commerce', 'Application web', 'Mini SaaS', 'Outil interne', 'Tableau de bord', 'Autre'],
        features: 'Fonctionnalités souhaitées',
        featuresPlaceholder: 'Ex: formulaire de contact, paiements en ligne, espace client, etc.',
        budget: 'Budget estimé',
        budgets: ['Moins de 800 $', '800 $ – 1 200 $', '1 200 $ – 1 800 $', '1 800 $ – 3 000 $', '3 000 $ et plus', 'À discuter'],
        deadline: 'Délai souhaité',
        deadlines: ['Dès que possible', '1 à 2 mois', '2 à 4 mois', '4 à 6 mois', 'Plus de 6 mois', 'Flexible'],
        message: 'Description détaillée du projet',
        messagePlaceholder: 'Décrivez votre projet en détail : contexte, objectifs, public cible, inspirations, contraintes...',
        submit: 'Envoyer ma demande de devis',
        sending: 'Envoi en cours...',
        success: 'Votre demande de devis a été envoyée ! Nous vous répondrons sous 24-48h ouvrables avec une proposition adaptée.',
        error: 'Une erreur s\'est produite. Veuillez réessayer.',
      }
    },
    footer: {
      tagline: 'Développement web premium, applications sur mesure et solutions numériques pour les entreprises qui veulent aller plus loin.',
      quickLinks: 'Liens rapides',
      ourServices: 'Nos services',
      contact: 'Contact',
      address: '114 rue des Pruniers, Lévis, QC G6V 8W2',
      phone: '(581) 700-4171',
      email: 'contact@exevori.com',
      copyright: '© 2025 Exevori. Tous droits réservés.',
      legal: 'Mentions légales',
      privacy: 'Politique de confidentialité',
    },
    notFound: {
      title: 'Page introuvable',
      subtitle: 'La page que vous recherchez n\'existe pas ou a été déplacée.',
      cta: 'Retour à l\'accueil',
    },
    legalPage: {
      title: 'Mentions légales & Politique de confidentialité',
      sections: [
        {
          title: 'Informations sur l\'entreprise',
          content: 'Exevori est une entreprise de développement web et numérique. Adresse : 114 rue des Pruniers, Lévis, QC G6V 8W2. Téléphone : (581) 700-4171. Courriel : contact@exevori.com',
        },
        {
          title: 'Politique de confidentialité',
          content: 'Exevori s\'engage à protéger la vie privée de ses clients et visiteurs. Les informations personnelles collectées via nos formulaires (nom, courriel, téléphone) sont utilisées uniquement pour répondre à vos demandes et ne sont jamais partagées avec des tiers sans votre consentement.',
        },
        {
          title: 'Collecte des données',
          content: 'Nous collectons uniquement les données que vous nous fournissez volontairement via nos formulaires de contact et de demande de devis. Ces données sont stockées de manière sécurisée et utilisées uniquement à des fins commerciales légitimes.',
        },
        {
          title: 'Droits des utilisateurs',
          content: 'Conformément à la Loi sur la protection des renseignements personnels dans le secteur privé (Loi 25) du Québec, vous avez le droit d\'accéder à vos données personnelles, de les corriger ou de demander leur suppression. Contactez-nous à : contact@exevori.com',
        },
        {
          title: 'Utilisation des cookies',
          content: 'Notre site utilise des cookies techniques essentiels au bon fonctionnement du site. Aucun cookie publicitaire tiers n\'est utilisé sans votre consentement explicite.',
        },
        {
          title: 'Limitation de responsabilité',
          content: 'Exevori ne peut être tenu responsable des dommages indirects résultant de l\'utilisation de ce site. Les informations présentées sont fournies à titre indicatif et peuvent être modifiées sans préavis.',
        },
      ]
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      process: 'Process',
      about: 'About',
      faq: 'FAQ',
      contact: 'Contact',
      quote: 'Get a Quote',
    },
    hero: {
      overline: 'Digital Agency',
      title: 'Custom Web Development, SaaS & Digital Solutions',
      subtitle: 'Exevori builds modern websites, high-performance applications, and smart digital solutions to help businesses gain credibility, efficiency, and growth.',
      cta1: 'Request a Quote',
      cta2: 'Explore Our Services',
    },
    credibility: {
      title: 'Complete expertise, a tailored approach',
      items: [
        { title: 'Premium Design', desc: 'Modern sites that inspire trust' },
        { title: 'Custom Solutions', desc: 'Development adapted to your needs' },
        { title: 'Smart Automation', desc: 'Save time with our AI tools' },
        { title: 'Guaranteed Performance', desc: 'Fast, optimized, reliable sites' },
        { title: 'Human Support', desc: 'A partner at every project stage' },
        { title: 'Business Vision', desc: 'Solutions built for your growth' },
      ]
    },
    services: {
      overline: 'Our Services',
      title: 'Digital solutions for every need',
      subtitle: 'Exevori offers a complete range of services to boost your digital presence and optimize your operations.',
      learnMore: 'Learn more',
      items: [
        { title: 'Website Development', desc: 'Modern, fast, conversion-oriented showcase websites designed to represent your brand professionally.', icon: 'Globe' },
        { title: 'Custom Web Applications', desc: 'Platforms, client portals, dashboards, and internal tools developed to your exact specifications.', icon: 'Code2' },
        { title: 'SaaS Solutions', desc: 'Purpose-built web software for specific business needs or precise market niches.', icon: 'Layers' },
        { title: 'Process Automation', desc: 'Automation of repetitive tasks, forms, tracking, and workflows to gain efficiency.', icon: 'Zap' },
        { title: 'AI for Business', desc: 'Integration of intelligent features to enhance customer experience and optimize operations.', icon: 'Brain' },
        { title: 'Digital Redesign', desc: 'Modernization of your existing website: UX/UI, performance, brand credibility, and SEO.', icon: 'RefreshCw' },
      ]
    },
    whyExevori: {
      overline: 'Why Exevori?',
      title: 'A professional image that makes the difference',
      items: [
        { title: 'Personalized Solutions', desc: 'Every project is unique. We design solutions that exactly meet your goals and business reality.' },
        { title: 'Professional Design', desc: 'Modern, polished, credible interfaces that strengthen your image and inspire trust.' },
        { title: 'Results-Oriented Approach', desc: 'Every technical decision is guided by your business success, not just technology.' },
        { title: 'Full Support', desc: 'From strategy to go-live, we are by your side at every step with clarity and transparency.' },
      ]
    },
    portfolio: {
      overline: 'Portfolio',
      title: 'Projects built to perform',
      subtitle: 'Discover some examples of solutions we have developed.',
      viewAll: 'View all projects',
      projects: [
        { name: 'Construction Site', type: 'Website', client: 'Construction company', desc: 'Professional website with service presentation, portfolio, and quote request form.', tags: ['React', 'Design Premium', 'SEO'] },
        { name: 'Plumbing Site', type: 'Website', client: 'Plumbing service', desc: 'Modern website with quick contact system and service presentation.', tags: ['React', 'Responsive', 'Contact'] },
        { name: 'Restaurant Site', type: 'Website Premium', client: 'Restaurant', desc: 'Elegant website with interactive menu, online booking system, and photo gallery.', tags: ['React', 'Design Luxe', 'Reservations'] },
      ]
    },
    process: {
      overline: 'Our Process',
      title: 'A clear method for concrete results',
      subtitle: 'Every project follows a structured process that ensures quality, transparency, and on-time delivery.',
      steps: [
        { num: '01', title: 'Needs Analysis', desc: 'We take the time to understand your goals, market, and constraints before proposing anything.' },
        { num: '02', title: 'Strategy & Scoping', desc: 'Clear definition of scope, features, architecture, and project timeline.' },
        { num: '03', title: 'Design & UX', desc: 'Design of modern, intuitive interfaces aligned with your brand identity.' },
        { num: '04', title: 'Development', desc: 'Rigorous development using modern, high-performance code practices.' },
        { num: '05', title: 'Launch & Optimization', desc: 'Go-live, thorough testing, post-launch monitoring, and continuous optimization.' },
      ]
    },
    testimonials: {
      overline: 'Testimonials',
      title: 'What our clients say',
      items: []
    },
    finalCta: {
      title: 'Do you have a digital project?',
      subtitle: 'Exevori helps you transform your idea into a concrete, modern, and high-performance solution. Let\'s talk about your project.',
      cta1: 'Talk about my project',
      cta2: 'Request an estimate',
    },
    servicesPage: {
      hero: {
        overline: 'Our Services',
        title: 'Complete digital solutions for your business',
        subtitle: 'From design to deployment, Exevori supports you with expertise and professionalism.',
      },
      items: [
        { icon: 'Globe', title: 'Professional Websites', subtitle: 'Your digital showcase, reimagined', desc: 'We create websites that aren\'t just beautiful — they\'re built to convert. Every detail is considered: information architecture, technical performance, responsive design, and SEO.', benefits: ['Modern design aligned with your brand', 'Optimized for local SEO', 'Perfect responsive on all devices', 'Contact forms and integrations', 'Fast loading and clean code'], clients: 'Retailers, professionals, SMBs, organizations' },
        { icon: 'Code2', title: 'Custom Web Applications', subtitle: 'Tools built to your specifications', desc: 'When generic solutions fall short, we develop fully customized web applications. Client portals, management dashboards, analytics platforms, booking systems — whatever your business needs.', benefits: ['Scalable and maintainable architecture', 'Intuitive modern UI', 'Integration with your existing tools', 'Custom database design', 'Security and performance guaranteed'], clients: 'SMBs, growing businesses, startups' },
        { icon: 'Layers', title: 'SaaS Solutions', subtitle: 'Your idea transformed into software', desc: 'Have a digital product idea or specific business need? Exevori designs and develops turnkey mini SaaS: from product strategy to UI, technical architecture to go-live.', benefits: ['Fast MVP to validate your idea', 'Cloud-native architecture', 'User management system', 'Admin dashboard', 'Scalable as you grow'], clients: 'Entrepreneurs, startups, innovative businesses' },
        { icon: 'Zap', title: 'Process Automation', subtitle: 'Free your time for what matters', desc: 'We analyze your operations and identify repetitive tasks that can be automated. Smart forms, processing workflows, automatic notifications, data synchronization — your teams gain productivity.', benefits: ['Reduction of repetitive manual tasks', 'Automatically triggered workflows', 'Smart notifications and reminders', 'Integration with your business tools', 'Automated tracking and reports'], clients: 'Any business seeking greater efficiency' },
        { icon: 'Brain', title: 'AI for Business', subtitle: 'Technology in service of your performance', desc: 'AI is no longer reserved for large corporations. Exevori integrates intelligent features into your tools: virtual assistants, data analysis, content generation, automatic classification, and more.', benefits: ['Chatbots and virtual assistants', 'Data analysis and synthesis', 'AI-powered automation', 'Customer experience personalization', 'Automatic reports and insights'], clients: 'SMBs looking to innovate and stand out' },
        { icon: 'RefreshCw', title: 'Digital Redesign & Optimization', subtitle: 'Modernize your digital presence', desc: 'Does your existing site no longer reflect your current brand? Exevori performs complete or partial redesigns: new visual identity, UX improvement, performance and SEO optimization, technology update.', benefits: ['Complete audit of existing site', 'Modern new visual identity', 'Significant speed improvement', 'UX redesigned to convert more', 'Secure migration without data loss'], clients: 'Businesses with an aging website' },
      ]
    },
    portfolioPage: {
      hero: {
        overline: 'Our Work',
        title: 'Projects that speak for themselves',
        subtitle: 'Every project we deliver is the result of close collaboration, rigorous technical expertise, and careful design.',
      },
      filters: ['All', 'Website', 'Application', 'SaaS'],
      projects: [
        { name: 'Construction Site', type: 'Website', category: 'Website', client: 'Construction company', location: '', desc: 'Professional website with service presentation, portfolio, and quote request form.', objective: 'Create a professional online presence and generate quote requests', result: 'Modern and professional interface', tags: ['React', 'Design Premium', 'SEO', 'Responsive'], color: 'from-amber-500 to-orange-500', image: 'https://customer-assets.emergentagent.com/job_connected-work/artifacts/z7xoesbs_E2DAE32C-FC28-480A-82F7-2C22D3FC8514.png' },
        { name: 'Plumbing Site', type: 'Website', category: 'Website', client: 'Plumbing service', location: '', desc: 'Modern website with quick contact system and service presentation.', objective: 'Modernize web presence and facilitate contact', result: 'Intuitive and efficient interface', tags: ['React', 'Responsive', 'Contact', 'SEO'], color: 'from-blue-500 to-cyan-500', image: 'https://customer-assets.emergentagent.com/job_connected-work/artifacts/k8aburmo_E088F2AA-6C4A-4E33-978A-8F23A3FB2723.png' },
        { name: 'Restaurant Site', type: 'Website Premium', category: 'Website', client: 'Restaurant', location: '', desc: 'Elegant website with interactive menu, online booking system, and photo gallery.', objective: 'Reflect the restaurant ambiance and simplify bookings', result: 'High-end and functional design', tags: ['React', 'Design Luxe', 'Reservations', 'Gallery'], color: 'from-amber-700 to-yellow-600', image: 'https://customer-assets.emergentagent.com/job_connected-work/artifacts/66utq2we_E1840B20-EFC3-4B4E-891E-21B6BEEA144B.png' },
        { name: 'ComptaPro IA', type: 'SaaS', category: 'SaaS', client: 'Solution in development', location: '', desc: 'AI-powered accounting software to automate data entry, categorization, and financial reports.', objective: 'Simplify SMB accounting with AI', result: 'In development', tags: ['React', 'FastAPI', 'AI', 'MongoDB'], color: 'from-violet-500 to-purple-700' },
        { name: 'AssistPro IA', type: 'SaaS', category: 'SaaS', client: 'Solution in development', location: '', desc: 'Intelligent virtual assistant for businesses, capable of answering customer questions and qualifying leads.', objective: 'Offer automated and intelligent customer support', result: 'In development', tags: ['React', 'OpenAI', 'Node.js', 'Real-time'], color: 'from-emerald-500 to-teal-600' },
        { name: 'DevisPro IA', type: 'SaaS', category: 'SaaS', client: 'Solution in development', location: '', desc: 'Platform for automatic generation of quotes and commercial proposals with AI assistance.', objective: 'Accelerate creation of professional quotes', result: 'In development', tags: ['React', 'FastAPI', 'AI', 'PDF'], color: 'from-cyan-500 to-blue-600' },
      ]
    },
    aboutPage: {
      hero: {
        overline: 'About Exevori',
        title: 'A company built on expertise and trust',
        subtitle: 'Exevori supports businesses in creating modern, high-performance, and useful digital tools.',
      },
      story: {
        overline: 'Our Story',
        title: 'Born from a passion for digital',
        desc1: 'Exevori is a web and digital development agency. We were founded with a clear vision: to make modern technologies accessible and useful for SMBs and entrepreneurs.',
        desc2: 'Our team combines strategy, design, development and business vision to create solutions that strengthen our clients\' image, efficiency, and growth. Every project is handled with rigor, creativity, and a keen business sense.',
        desc3: 'Whether you need a showcase site, a complex web application, or a SaaS solution, Exevori is the technology partner that will accompany you from idea to launch.',
      },
      mission: {
        overline: 'Mission & Vision',
        title: 'Helping businesses perform better through digital',
        mission: 'Our mission is to help businesses build a strong, credible, and effective digital presence through modern custom solutions.',
        vision: 'Our vision is to become the reference digital partner for SMBs that want to stand out.',
      },
      values: {
        overline: 'Our Values',
        title: 'What guides us every day',
        items: [
          { title: 'Professionalism', desc: 'We treat every project with the same seriousness and rigor, regardless of size.' },
          { title: 'Innovation', desc: 'We use the most modern technologies to offer you solutions that stand the test of time.' },
          { title: 'Clarity', desc: 'Simple and transparent communication at every stage — no jargon, no surprises.' },
          { title: 'Quality', desc: 'We don\'t deliver just to deliver. Every detail matters and every deliverable should make you proud.' },
          { title: 'Trust', desc: 'We build lasting relationships based on respecting commitments and transparency.' },
          { title: 'Performance', desc: 'Optimized, fast, and reliable solutions that support your long-term growth.' },
        ]
      },
      cta: {
        title: 'Ready to work with Exevori?',
        subtitle: 'Let\'s discuss your project and see how we can help you achieve your goals.',
        btn: 'Start a project',
      }
    },
    processPage: {
      hero: {
        overline: 'Our Method',
        title: 'A structured process for predictable results',
        subtitle: 'We have developed a proven work method that guarantees quality, transparency, and delivery within agreed timelines.',
      },
      steps: [
        { num: '01', title: 'Needs Analysis', subtitle: 'Understand before proposing', desc: 'Everything starts with an in-depth discussion to understand your business goals, market, constraints, and expectations. We ask the right questions to pinpoint exactly what you need.', deliverables: ['Needs analysis report', 'Key objectives identified', 'Initial scope proposal'] },
        { num: '02', title: 'Strategy & Scoping', subtitle: 'Define a clear action plan', desc: 'Based on the analysis, we define the exact project scope, priority features, technical architecture, timeline, and budget. Everything is documented and validated with you.', deliverables: ['Functional specifications', 'Technical architecture', 'Detailed project plan'] },
        { num: '03', title: 'UX/UI Design', subtitle: 'Interfaces that convert', desc: 'Our designer creates modern, intuitive interfaces aligned with your brand identity. We create detailed mockups and validate them with you before any development begins.', deliverables: ['High-fidelity mockups', 'Interactive prototype', 'Validated style guide'] },
        { num: '04', title: 'Development & Integration', subtitle: 'Clean, high-performance code', desc: 'Our team develops the solution according to modern best practices. Regular reviews let you track progress and validate deliverables along the way.', deliverables: ['Documented source code', 'Test environment', 'Regular demonstrations'] },
        { num: '05', title: 'Launch & Optimization', subtitle: 'A smooth go-live with rigorous follow-up', desc: 'We manage the go-live, conduct thorough testing, and ensure post-launch monitoring. Data-driven optimizations are implemented to maximize results.', deliverables: ['Production deployment', 'Training and documentation', 'Post-launch performance report'] },
      ],
      getWith: {
        title: 'What you get with Exevori',
        items: [
          'A clear vision and structured plan from day one',
          'Simple and regular communication throughout the project',
          'Professional deliverables at each validated stage',
          'A modern, polished user experience',
          'A solution perfectly adapted to your objectives',
          'Post-launch support and follow-up',
        ]
      }
    },
    faqPage: {
      hero: {
        overline: 'FAQ',
        title: 'Your questions, our answers',
        subtitle: 'Have questions about our services or how we work? Find the answers below.',
      },
      items: [
        { q: 'What types of projects do you work on?', a: 'Exevori handles a wide variety of digital projects: showcase websites, e-commerce stores, custom web applications, mini SaaS, CRMs, client portals, process automation, and AI integration. If you have a digital need, we likely have the solution.' },
        { q: 'Do you work with SMBs and small businesses?', a: 'Absolutely. The majority of our clients are SMBs, independent professionals, and retailers. We adapt our approach and solutions to your reality — budget, internal capacity, deadlines — without compromising on quality.' },
        { q: 'Do you offer fully custom solutions?', a: 'Yes, that\'s our specialty. Unlike generic off-the-shelf solutions, everything we develop is designed specifically for your needs. This ensures better alignment with your business reality and a real competitive advantage.' },
        { q: 'How long does a typical project take?', a: 'Duration depends on complexity. A simple showcase site can be delivered in 2 to 4 weeks. A custom web application typically takes 6 to 12 weeks. We define a precise timeline during the scoping phase and stick to it.' },
        { q: 'Can the site or application evolve later?', a: 'Yes, and that\'s essential. We develop with a scalable architecture that allows adding features, modifying sections, or integrating new tools as your business evolves.' },
        { q: 'Do you offer post-delivery support?', a: 'Yes. We offer post-launch support for fixes, updates, and optimizations. We can also establish a regular maintenance agreement based on your needs.' },
        { q: 'Can you modernize an existing site?', a: 'Absolutely. Site redesign is one of our most in-demand services. We first conduct a complete audit, then propose a partial or complete redesign based on the current state and your objectives.' },
        { q: 'Do you offer internal tools or SaaS?', a: 'Yes. We develop custom internal tools (CRM, portals, dashboards) and mini SaaS for specific niches. If you have a digital product idea, we can help you bring it to life.' },
        { q: 'Is it possible to integrate automation or AI features?', a: 'Absolutely. We integrate automation solutions (workflows, notifications, processing) and AI features (chatbots, data analysis, content generation) into your projects based on your needs.' },
        { q: 'How do I request a quote?', a: 'It\'s simple: fill out our quote request form by clicking "Get a Quote" at the top of the page. Describe your project in detail and we\'ll respond within 24 to 48 business hours with a tailored proposal.' },
        { q: 'What are your rates?', a: 'Our pricing is transparent and adapted to different project types:\n\n• Website update or light redesign: $800 – $1,200\n• Simple professional showcase site (5–10 pages): $1,200 – $1,800\n• Custom or more complex web project (e-commerce, automations, integrations): starting at $3,000\n\nEvery project is unique, and we always provide a detailed, no-obligation quote after a free initial consultation.' },
      ]
    },
    contactPage: {
      hero: {
        overline: 'Contact',
        title: 'Let\'s talk about your project',
        subtitle: 'Tell us about your project. We will respond with seriousness, clarity, and professionalism.',
      },
      form: {
        name: 'Full Name',
        company: 'Company (optional)',
        email: 'Email Address',
        phone: 'Phone (optional)',
        projectType: 'Project Type',
        projectTypes: ['Showcase Website', 'Web Application', 'SaaS / Digital Tool', 'Process Automation', 'Website Redesign', 'Other'],
        budget: 'Approximate Budget',
        budgets: ['Under $800', '$800 – $1,200', '$1,200 – $1,800', '$1,800 – $3,000', '$3,000+'],
        message: 'Describe your project',
        messagePlaceholder: 'Tell us about your project, needs, and goals...',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Your message was sent successfully! We will reply within 24-48 hours.',
        error: 'An error occurred. Please try again.',
      },
      info: {
        title: 'Our Contact Information',
        address: '114 rue des Pruniers, Lévis, QC G6V 8W2',
        phone: '(581) 700-4171',
        email: 'contact@exevori.com',
        hours: 'Monday – Friday: 9am to 5pm',
        response: 'Response within 24-48 business hours',
      }
    },
    devisPage: {
      hero: {
        overline: 'Quote Request',
        title: 'Tell us about your project',
        subtitle: 'Every project starts with a thorough understanding of your goals. Give us as much information as possible to receive a clear, tailored response.',
      },
      form: {
        personal: 'Your Contact Info',
        project: 'Your Project',
        name: 'Full Name',
        company: 'Company',
        email: 'Email Address',
        phone: 'Phone',
        sector: 'Industry',
        sectors: ['Commerce / Retail', 'Professional Services', 'Health / Wellness', 'Construction / Real Estate', 'Restaurants / Hospitality', 'Technology', 'Education', 'Other'],
        need: 'Primary Need',
        needs: ['Create a new website', 'Develop an application', 'Create a SaaS', 'Automate processes', 'Redesign existing site', 'AI Integration', 'Other'],
        solution: 'Type of Solution Needed',
        solutions: ['Showcase site', 'E-commerce', 'Web application', 'Mini SaaS', 'Internal tool', 'Dashboard', 'Other'],
        features: 'Desired Features',
        featuresPlaceholder: 'e.g., contact form, online payments, client portal, etc.',
        budget: 'Estimated Budget',
        budgets: ['Under $800', '$800 – $1,200', '$1,200 – $1,800', '$1,800 – $3,000', '$3,000+', 'To be discussed'],
        deadline: 'Desired Timeline',
        deadlines: ['As soon as possible', '1 to 2 months', '2 to 4 months', '4 to 6 months', 'More than 6 months', 'Flexible'],
        message: 'Detailed project description',
        messagePlaceholder: 'Describe your project in detail: context, goals, target audience, inspirations, constraints...',
        submit: 'Submit Quote Request',
        sending: 'Sending...',
        success: 'Your quote request has been sent! We will respond within 24-48 business hours with a tailored proposal.',
        error: 'An error occurred. Please try again.',
      }
    },
    footer: {
      tagline: 'Premium web development, custom applications, and digital solutions for businesses that want to go further.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contact: 'Contact',
      address: '114 rue des Pruniers, Lévis, QC G6V 8W2',
      phone: '(581) 700-4171',
      email: 'contact@exevori.com',
      copyright: '© 2025 Exevori. All rights reserved.',
      legal: 'Legal Notice',
      privacy: 'Privacy Policy',
    },
    notFound: {
      title: 'Page Not Found',
      subtitle: 'The page you are looking for does not exist or has been moved.',
      cta: 'Back to Home',
    },
    legalPage: {
      title: 'Legal Notice & Privacy Policy',
      sections: [
        { title: 'Company Information', content: 'Exevori is a web and digital development company. Address: 114 rue des Pruniers, Lévis, QC G6V 8W2. Phone: (581) 700-4171. Email: contact@exevori.com' },
        { title: 'Privacy Policy', content: 'Exevori is committed to protecting the privacy of its clients and visitors. Personal information collected through our forms (name, email, phone) is used only to respond to your requests and is never shared with third parties without your consent.' },
        { title: 'Data Collection', content: 'We only collect data that you voluntarily provide through our contact and quote request forms. This data is stored securely and used only for legitimate business purposes.' },
        { title: 'User Rights', content: 'In accordance with Quebec\'s Act Respecting the Protection of Personal Information in the Private Sector (Law 25), you have the right to access your personal data, correct it, or request its deletion. Contact us at: contact@exevori.com' },
        { title: 'Cookie Usage', content: 'Our site uses essential technical cookies for proper website operation. No third-party advertising cookies are used without your explicit consent.' },
        { title: 'Limitation of Liability', content: 'Exevori cannot be held liable for indirect damages resulting from the use of this site. Information presented is provided for informational purposes and may be modified without notice.' },
      ]
    },
  }
};
